import React, { useEffect, useState } from "react";
import { Tab, Tabs, Box, LinearProgress } from "@mui/material";

import ListActivities from "./components/ListActivities";
import { API_get_activities_not_hide, API_get_bookings_id } from "./utils/http";
import { useTasks, useTasksDispatch } from "./AppContext";
import InputLeftInfo from "./components/InputLeftInfo";
import InputLeftPrice from "./components/InputLeftPrice";
import ListAccom from "./components/ListAccom";
import InputLeftTax from "./components/InputLeftTax";
import { dispatchTYPE } from "./utils/constDispatch";
import { checkOper_or_admin } from "./utils/tool";
import OperDetail from "./components/operating/OperDetail";
import TabPDFDraft from "./components/pdf/TabPDFDraft";

export default function InputLeft({ booking_id }) {
  const data_pdf = useTasks();
  const dispatch = useTasksDispatch();

  const [accommondation, set_accommondation] = useState(null);
  const [activities, set_activities] = useState(null);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const uniqueByProperty = (arr, key) => {
    return arr.filter(
      (obj, index, self) =>
        index === self.findIndex((t) => t[key] === obj[key]),
    );
  };

  const findDuplicatesByProperty = (arr, key) => {
    const counts = new Map();
    const duplicates = [];

    arr.forEach((obj) => {
      const value = obj[key];
      counts.set(value, (counts.get(value) || 0) + 1);
    });

    arr.forEach((obj) => {
      if (counts.get(obj[key]) > 1) {
        duplicates.push(obj);
      }
    });

    return [...new Set(duplicates)]; // Remove duplicate duplicate objects if any
  };

  async function get_data_activities_accom() {
    API_get_activities_not_hide((data) => {
      // console.log(data.data.length);

      let new_acti = data.data.map((v) => ({ ...v, key: v._id }));
      let new_acti_uniqueData = uniqueByProperty(new_acti, "label");

      // let new_acti_duplicate = findDuplicatesByProperty(new_acti, "label");
      // console.log(new_acti_duplicate);

      // console.log(new_acti_uniqueData.length);
      set_activities(new_acti_uniqueData);
      set_accommondation(data.accom);
    });
  }

  async function get_data() {
    API_get_bookings_id(booking_id, (x) => {
      if (x.success) {
        let data = x.data;
        dispatch({
          type: dispatchTYPE.get_data_pdf,
          value: data,
        });
      }
    });
  }

  useEffect(() => {
    get_data_activities_accom();

    get_data();
  }, []);

  if (accommondation != null && data_pdf != null) {
    return (
      <Box sx={{ height: "100%" }}>
        <Box
          style={{ display: "flex", flexDirection: "column", height: "100%" }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="Info" />
            <Tab label="Actv" />
            <Tab label="Accom" />
            <Tab label="Price" />
            {checkOper_or_admin() ? <Tab label="TAX" /> : null}
            {checkOper_or_admin() ? <Tab label="price list" /> : null}
            {checkOper_or_admin() ? <Tab label="Draft" /> : null}
          </Tabs>

          <Box style={{ flex: 1, position: "relative", overflow: "hidden" }}>
            <Box
              style={{
                padding: 10,
                height: "100%",
                overflow: "auto",
                paddingBottom: "0px",
              }}
            >
              {value == 0 ? <InputLeftInfo booking_id={booking_id} /> : null}
              {value == 1 ? (
                <ListActivities
                  accommondation={accommondation}
                  activities={activities}
                  booking_id={booking_id}
                />
              ) : null}
              {value == 2 ? (
                <ListAccom
                  accommondation={accommondation}
                  booking_id={booking_id}
                />
              ) : null}
              {value == 3 ? <InputLeftPrice /> : null}
              {value == 4 ? (
                <InputLeftTax booking_id={booking_id} data_pdf={data_pdf} />
              ) : null}
              {value == 5 ? <OperDetail booking_id={booking_id} /> : null}
              {value == 6 ? (
                <Box
                  sx={{
                    display: "flex",
                    height: "100%",
                    flexDirection: "column",
                  }}
                >
                  <TabPDFDraft data_pdf={data_pdf} />
                </Box>
              ) : null}
            </Box>
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box sx={{ width: "100%", marginTop: 10 }}>
        <LinearProgress />
      </Box>
    );
  }
}
